import {
  Button,
  Input,
  message,
  Table,
  Col,
  Row,
  Select,
  PageHeader,
} from "antd";
import { createComponentStore, useStoreState } from "easy-peasy";
import { Controller, useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { LODGING_PAYMENT_TYPE, CURRENCY } from "Constants";
import {
  LodgingPaymentStoreModel,
  ACTION_TYPES,
} from "store/models/contracts/lodging-payment";
import DatePicker from "Components/date-picker-localized";
import moment from "moment";
import { isScreenMobile } from "Utils/";
import { AuthCheck, AUTH_ACTIONS } from "authorization";

export default function LodgingPaymentsList({}) {
  const { abilities } = useStoreState((store) => store.auth);
  const [tableData, setTableData] = useState([]);
  const [postData, setPostData] = useState([]);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [selectedDate, setSelectedDate] = useState();

  const form = useForm({ mode: "onChange" });

  const { control, watch } = form;
  const useLodgingPaymentStoreModel = createComponentStore(
    LodgingPaymentStoreModel
  );
  const [store, actions] = useLodgingPaymentStoreModel();

  const { fetch, create } = actions;

  useEffect(() => {
    onDateSelected(moment(new Date()));
  }, []);

  useEffect(() => {
    if (store.process === ACTION_TYPES.FETCHED_DATA) {
      setTableData(store.data);

      if (store.data.length === 0) return;

      delete store.data.blockNo;

      let postData = {
        bodies: [],
        year: store.data[0].year,
        month: store.data[0].month,
      };
      store.data.forEach((item) => {
        postData.bodies.push({
          contract: { id: item.contractId },
          lodgingRent: item.lodgingRent,
          currency: item.currency,
          amountOfPayment: item.amountOfPayment,
          id: item?.id,
          version: item?.version,
          description: item.paymentDescription || "",
        });
      });
      setPostData(postData);
    }

    if (
      store.process === ACTION_TYPES.UPDATED_DATA ||
      store.process === ACTION_TYPES.CREATED_DATA
    ) {
      message.success(`Ödeme listesi güncellendi.`);
    }
  }, [store.process]);

  const onDateSelected = (date) => {
    setTableData([]);
    if (date) {
      setSelectedDate(date);
      if (AuthCheck(abilities, AUTH_ACTIONS.READ, "Lojman Kira Ödeme Listesi"))
        fetch({ year: date.year(), month: date.month() + 1 });
    }
    setSubmitDisabled(true);
  };

  const handleSelectChange = (selectChange, record) => {
    let newPostData = { ...postData };
    newPostData.bodies.find(
      (item) => item.contract.id === record.contractId
    ).lodgingRent = selectChange;
    setSubmitDisabled(false);
  };

  const handleOnSubmit = () => {
    let p_data = { ...postData };

    p_data.bodies.forEach((d) => {
      d.description = form.getValues()["paymentDesc_" + d.contract.id];
      d.currency = form.getValues()["currency_" + d.contract.id];
      d.amountOfPayment = form.getValues()["paymentAmount_" + d.contract.id];
    });
    create(p_data).then(() => {
      onDateSelected(selectedDate);
    });
  };

  const getTableData = (recorded) => {
    return recorded
      ? tableData.filter((d) => d.lodgingRent)
      : tableData.filter((d) => !d.lodgingRent);
  };

  const columns = [
    {
      title: "Kod",
      dataIndex: "contractCode",
      key: "contractCode",
      width: 100,
      ellipsis: true,
      editable: false,
    },
    {
      title: "Sözleşme Açıklaması",
      dataIndex: "contractDescription",
      key: "contractDescription",
      width: 350,
      ellipsis: true,
      editable: false,
    },
    {
      title: "Kiracı Kimlik No",
      dataIndex: "contractPartnerIdentityNo",
      key: "contractPartnerIdentityNo",
      ellipsis: true,
      editable: false,
    },
    {
      title: "Kiracı Adı",
      dataIndex: "contractPartnerName",
      key: "contractPartnerName",
      ellipsis: true,
      defaultSortOrder: "ascend",
      sorter: (a, b) =>
        (a.contractPartnerName + a.contractPartnerSurName).localeCompare(
          b.contractPartnerName + b.contractPartnerSurName
        ),
      render: (text, record) =>
        record.contractPartnerName + " " + record.contractPartnerSurName,
      editable: false,
    },

    {
      title: "Blok",
      dataIndex: "blockNo",
      key: "blockNo",
      width: 70,
      ellipsis: true,
      editable: false,
    },

    {
      title: "Kat",
      dataIndex: "floor",
      key: "floor",
      width: 70,
      ellipsis: true,
      editable: false,
    },

    {
      title: "Daire",
      dataIndex: "flat",
      key: "flat",
      width: 70,
      ellipsis: true,
      editable: false,
    },

    {
      title: "Kira Ödeme Bilgisi",
      dataIndex: "lodgingRent",

      sorter: (a, b) => a?.lodgingRent?.localeCompare(b?.lodgingRent),
      key: "lodgingRent",

      render: (text, record) => (
        <Controller
          control={control}
          name={"paymentSelect_" + record.contractId}
          defaultValue={record.lodgingRent}
          as={
            <Select
              style={{ width: "80%" }}
              onSelect={(change) => {
                handleSelectChange(change, record);
              }}
            >
              {Object.entries(LODGING_PAYMENT_TYPE).map(([key, value]) => (
                <Select.Option key={key} value={key}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          }
        />
      ),
      editable: false,
    },

    {
      title: "Tutar ",
      dataIndex: "amountOfPayment",
      key: "amountOfPayment",
      render: (text, record) => {
        return (
          <Row>
            <Col xs={24} sm={12} lg={16}>
              <Controller
                control={control}
                name={"paymentAmount_" + record.contractId}
                defaultValue={record.amountOfPayment}
                as={
                  <Input
                    disabled={
                      watch()["paymentSelect_" + record.contractId] !==
                      "PARTIALLY_PAID"
                    }
                  />
                }
              />
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Controller
                control={control}
                name={"currency_" + record.contractId}
                disabled={
                  watch()["paymentSelect_" + record.contractId] !==
                  "PARTIALLY_PAID"
                }
                defaultValue={record.currency}
                as={
                  <Select>
                    {Object.entries(CURRENCY).map((c) => (
                      <Select.Option value={c[0]} key={c[0]}>
                        {c[1]}
                      </Select.Option>
                    ))}
                  </Select>
                }
              />
            </Col>
          </Row>
        );
      },
      editable: false,
    },

    {
      title: "Ödeme Açıklaması",
      dataIndex: "paymentDescription",
      key: "paymentDescription",
      render: (text, record) => {
        return (
          <Controller
            control={control}
            name={"paymentDesc_" + record.contractId}
            defaultValue={record.paymentDescription}
            as={<Input />}
          />
        );
      },
      editable: false,
    },
  ];

  return (
    <>
      <PageHeader
        title="Lojman Kiraları Ödeme Listesi"
        extra={[
          <Button
            key="paid"
            type="primary"
            onClick={() => {
              tableData.forEach((d) => {
                handleSelectChange("PAID", d);
                form.setValue("paymentSelect_" + d.contractId, "PAID");
              });
            }}
          >
            Tümü Ödendi
          </Button>,
          <Button
            key="clear"
            type="danger"
            onClick={() => {
              tableData.forEach((d) => {
                form.setValue("paymentSelect_" + d.contractId, null);
                form.setValue("paymentDesc_" + d.contractId, null);
              });
            }}
          >
            Temizle
          </Button>,

          <Button
            style={{ width: 160, marginLeft: 10 }}
            onClick={handleOnSubmit}
            loading={store.process === ACTION_TYPES.CREATING_DATA}
            disabled={submitDisabled}
          >
            Kaydet
          </Button>,

          <DatePicker
            key="filter"
            picker="month"
            onChange={onDateSelected}
            defaultValue={moment(new Date())}
            placeholder="Ödeme listesini görüntülemek istediğiniz dönemi seçiniz."
            style={{ width: isScreenMobile() ? 120 : 450 }}
          />,
        ]}
      />
      <form style={{ margin: "0 24px" }}>
        <Table
          rowKey={(row) => row.id}
          bordered
          title={() => "Ödeme Bilgisi Olmayan Kayıtlar"}
          scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
          dataSource={getTableData(false)}
          columns={columns}
          size="small"
          loading={store.process === ACTION_TYPES.FETCHING_DATA}
          rowClassName="editable-row"
        />
        <Table
          rowKey={(row) => row.id}
          bordered
          title={() => "Ödeme Bilgisi Olan Kayıtlar"}
          scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
          dataSource={getTableData(true)}
          columns={columns}
          size="small"
          loading={store.process === ACTION_TYPES.FETCHING_DATA}
          rowClassName="editable-row"
        />
      </form>
    </>
  );
}
